import React, { useState } from 'react';
import { Table, Typography } from 'antd';
import { TableWrapper } from 'ui/TableWrapper';
import {
  bccColumns,
  cardPaymentColumns,
  cardReversalPaymentColumns,
  clientsPaymentColumns,
  bccNestedColumns,
} from './datasource';

function PaymentInfoTables({ loading, payments }) {
  const { cardPayments, clientsPayments, cardReversalPayments, bccPayments } =
    payments;
  const [bccActiveRowRegisters, setBccActiveRowRegisters] = useState([]);
  const [bccExpandedKey, setBccExpandedKey] = useState([]);

  const renderBccRegistersTable = () => {
    return (
      <Table
        className="nested-table"
        columns={bccNestedColumns}
        rowKey="iin"
        dataSource={bccActiveRowRegisters}
        tableLayout="fixed"
        pagination={false}
      />
    );
  };

  const handleBccRowExpand = (expanded, record) => {
    if (expanded) {
      setBccActiveRowRegisters(record?.registers);
      setBccExpandedKey([record.id]);
    } else {
      setBccExpandedKey([]);
    }
  };

  return (
    <>
      {cardPayments && (
        <TableWrapper isPaginated={!cardPayments.length}>
          <Typography.Title level={5}>Карточные платежи</Typography.Title>

          <Table
            columns={cardPaymentColumns}
            dataSource={cardPayments}
            scroll={{ x: 900 }}
            tableLayout="fixed"
            loading={loading}
            rowKey="id"
          />
        </TableWrapper>
      )}

      {clientsPayments && (
        <TableWrapper isPaginated={!clientsPayments.length}>
          <Typography.Title level={5}>
            Выставленные клиенту платежи
          </Typography.Title>

          <Table
            columns={clientsPaymentColumns}
            dataSource={clientsPayments}
            scroll={{ x: 900 }}
            tableLayout="fixed"
            loading={loading}
            rowKey="id"
          />
        </TableWrapper>
      )}

      {cardReversalPayments && (
        <TableWrapper isPaginated={!cardReversalPayments.length}>
          <Typography.Title level={5}>Возвратные платежи</Typography.Title>

          <Table
            columns={cardReversalPaymentColumns}
            dataSource={cardReversalPayments}
            tableLayout="fixed"
            scroll={{ x: 900 }}
            loading={loading}
            rowKey="id"
          />
        </TableWrapper>
      )}

      {bccPayments && (
        <TableWrapper isPaginated={!bccPayments.length}>
          <Typography.Title level={5}>
            Отправленный в БЦК платежи
          </Typography.Title>

          <Table
            columns={bccColumns}
            dataSource={bccPayments}
            expandable={{
              expandedRowRender: renderBccRegistersTable,
              onExpand: handleBccRowExpand,
              expandedRowKeys: bccExpandedKey,
            }}
            scroll={{ x: 900 }}
            loading={loading}
            rowKey="id"
          />
        </TableWrapper>
      )}
    </>
  );
}

export { PaymentInfoTables };
